// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ModuleDesign_TheComp__FYtci","moduleDesignComponent":"ModuleDesign_moduleDesignComponent__cfgYF"};